import { PlaceData } from '../types/Place'
import { getDateKeyBeforeNDays, isUpdatedAtToday } from '../utils/date'
import { toLocationGroupId } from './identify'

const SEARCH_KEY = 'FORK#SEARCH'

const END_POINT =
  ' https://ltnirn09tb.execute-api.ap-northeast-2.amazonaws.com/places'

export const getSevenDaysPlaces = async (groupCode: string) => {
  const data = window.localStorage.getItem(SEARCH_KEY)
  const isUpdated = isUpdatedAtToday()
  const todayKey = getDateKeyBeforeNDays(isUpdated ? 0 : 1)

  if (data) {
    const searchedData = JSON.parse(data) ?? {}

    if (searchedData.recentlyDate === todayKey) {
      return searchedData.data
    }
  }

  const weekAgoDayKey = getDateKeyBeforeNDays(6)
  const response = await fetch(
    `${END_POINT}?locationGroupId=${toLocationGroupId(
      groupCode
    )}&searchedAt=${weekAgoDayKey}`
  )
  const places = (await response.json()) as PlaceData[]
  const sortedPlaces = places.sort(
    (a, b) => Number(a.distance.N) - Number(b.distance.N)
  )

  window.localStorage.setItem(
    SEARCH_KEY,
    JSON.stringify({
      recentlyDate: todayKey,
      data: sortedPlaces,
    })
  )

  return sortedPlaces
}

export const removeAllPlaces = async () => {
  window.localStorage.removeItem(SEARCH_KEY)
}
